var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 1h3a.5.5 0 0 1 .5.5V2H4v-.5a.5.5 0 0 1 .5-.5M3 2v-.5A1.5 1.5 0 0 1 4.5 0h3A1.5 1.5 0 0 1 9 1.5V2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm-.5 2a.5.5 0 0 1 .5.5V10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4.5a.5.5 0 0 1 1 0V10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4.5a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v5a.5.5 0 1 0 1 0zM7 4a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 1 7 4",
    clipRule: "evenodd"
  })));
});
const SvgDeletesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeletesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgMUg3LjVDNy43NzYxNCAxIDggMS4yMjM4NiA4IDEuNVYySDRWMS41QzQgMS4yMjM4NiA0LjIyMzg2IDEgNC41IDFaTTMgMlYxLjVDMyAwLjY3MTU3MyAzLjY3MTU3IDAgNC41IDBINy41QzguMzI4NDMgMCA5IDAuNjcxNTczIDkgMS41VjJIMTAuNUMxMC43NzYxIDIgMTEgMi4yMjM4NiAxMSAyLjVDMTEgMi43NzYxNCAxMC43NzYxIDMgMTAuNSAzSDlIOEg0SDNIMS41QzEuMjIzODYgMyAxIDIuNzc2MTQgMSAyLjVDMSAyLjIyMzg2IDEuMjIzODYgMiAxLjUgMkgzWk0yLjUgNEMyLjc3NjE0IDQgMyA0LjIyMzg2IDMgNC41VjEwQzMgMTAuNTUyMyAzLjQ0NzcyIDExIDQgMTFIOEM4LjU1MjI4IDExIDkgMTAuNTUyMyA5IDEwVjQuNUM5IDQuMjIzODYgOS4yMjM4NiA0IDkuNSA0QzkuNzc2MTQgNCAxMCA0LjIyMzg2IDEwIDQuNVYxMEMxMCAxMS4xMDQ2IDkuMTA0NTcgMTIgOCAxMkg0QzIuODk1NDMgMTIgMiAxMS4xMDQ2IDIgMTBWNC41QzIgNC4yMjM4NiAyLjIyMzg2IDQgMi41IDRaTTUuNSA0LjVDNS41IDQuMjIzODYgNS4yNzYxNCA0IDUgNEM0LjcyMzg1IDQgNC41IDQuMjIzODYgNC41IDQuNVY5LjVDNC41IDkuNzc2MTQgNC43MjM4NSAxMCA1IDEwQzUuMjc2MTQgMTAgNS41IDkuNzc2MTQgNS41IDkuNVY0LjVaTTcgNEM3LjI3NjE0IDQgNy41IDQuMjIzODYgNy41IDQuNVY5LjVDNy41IDkuNzc2MTQgNy4yNzYxNCAxMCA3IDEwQzYuNzIzODUgMTAgNi41IDkuNzc2MTQgNi41IDkuNVY0LjVDNi41IDQuMjIzODYgNi43MjM4NSA0IDcgNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";